import defaultReducer from "./defaultReducer";
import { defaultGrid } from "../../helpers/datagrid";

const initialState = { 
    open: false,
    grid: defaultGrid,
    periods: [],
    currentWeek: true
}

export default defaultReducer('PROMO_ANALYSIS_MODAL', initialState);